import { render, staticRenderFns } from "./notifications-panel-tabs.vue?vue&type=template&id=01b3b602"
import script from "./notifications-panel-tabs.vue?vue&type=script&lang=js"
export * from "./notifications-panel-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports